var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MultiEChartCard',{staticClass:"mb-4",attrs:{"data":_vm.chart,"loading":_vm.loading,"title":_vm.$t('dashboard.overview'),"group-by":_vm.timeRange.groupBy,"type":"time"},on:{"currentChart":_vm.setCurrentChart}})
}
var staticRenderFns = []

export { render, staticRenderFns }